import MainCatalogsEditorBase from '../../MainCatalogsEditorBase';
import { compose, mdsWidget, mdsLazyProto } from 'dojo/_base/declare';
import template from './EvTaskDescriptGroupEditor.html?raw';
import Edit from '../../../../moreCore/UI/Edit/Edit';
import NumberInput from '../../../../moreCore/UI/NumberInput/NumberInput';
import { MainCatalogTypes, MainCatalogs_Classes } from "../../../_loadingHelpers/MainCatalogTypes";

class EvTaskDescriptGroupEditor extends compose(MainCatalogsEditorBase) {
    templateString: any = template;

    dtg_Input_Description: MdsLax<InstanceType<typeof Edit>>;
    dtg_Input_Note: MdsLax<InstanceType<typeof Edit>>;
    dtg_Input_TextColor: HTMLInputElement;
    dtg_Input_BackgroundColor: HTMLInputElement;
    dtg_Input_Order: MdsLax<InstanceType<typeof NumberInput>>;

    formData: MainCatalogTypes.EvTaskDescriptGroup_SaveData = {
        ID: "",
        is_new_status: null,
        description: "",
        note: "",
        order: null,
        coloration: null
    };

    prepareFormData(data?: MainCatalogTypes.EvTaskDescriptGroup_LoadData): void {

        if (data) {

            this.dtg_Input_Description.setValue(data.description, true);
            this.dtg_Input_Note.setValue(data.note, true);

            this.dtg_Input_TextColor.value = data.coloration.TextColor.Hex;
            this.dtg_Input_BackgroundColor.value = data.coloration.BackColor.Hex;

            this.dtg_Input_Order.setValue(data.order, true);

            this.formData.ID = data.ID;
            this.formData.is_new_status = false;
        } else {

            this.dtg_Input_Description.setValue("", true);
            this.dtg_Input_Note.setValue("", true);

            this.dtg_Input_BackgroundColor.value = "#ffffff";
            this.dtg_Input_TextColor.value = "#000000";

            this.dtg_Input_Order.setValue(null, true);

            this.formData.ID = "";
            this.formData.is_new_status = true;
        }

        this.serializeFormData();
        this.originalData = JSON.stringify(this.formData);
        console.debug("ORIGINAL", this.originalData);
        this.StandbyStop();

        this.checkDirty();
    }

    serializeFormData(): void {

        this.formData.description = this.dtg_Input_Description.getValue();
        this.formData.note = this.dtg_Input_Note.getValue();

        this.formData.order = this.dtg_Input_Order.getValue();

        let coloration: MainCatalogTypes.PIT_Coloration = {
            TextColor: null,
            BackColor: null
        };
        let textColor: MainCatalogTypes.PIT_Color = {
            Hex: "",
            Red: 0,
            Green: 0,
            Blue: 0
        };
        let backColor: MainCatalogTypes.PIT_Color = {
            Hex: "",
            Red: 0,
            Green: 0,
            Blue: 0
        };
        let textHex = this.dtg_Input_TextColor.value;
        let backHex = this.dtg_Input_BackgroundColor.value;

        textColor.Hex = textHex;
        textColor.Red = parseInt(textHex.slice(1, 3), 16);
        textColor.Green = parseInt(textHex.slice(3, 5), 16);
        textColor.Blue = parseInt(textHex.slice(5, 7), 16);

        backColor.Hex = backHex;
        backColor.Red = parseInt(backHex.slice(1, 3), 16);
        backColor.Green = parseInt(backHex.slice(3, 5), 16);
        backColor.Blue = parseInt(backHex.slice(5, 7), 16);

        coloration.TextColor = textColor;
        coloration.BackColor = backColor;

        this.formData.coloration = coloration;

        console.debug("SERIALIZED DATA", this.formData);
    }

    _onChangeServiceCategoryInputData(): void {

        this.serializeFormData();
        this.checkDirty();
    }

    _onChangeInputNoteData(): void {

        this.fixNewLineInMultilineEdit(this.dtg_Input_Note);

        this.serializeFormData();
        this.checkDirty();
    }

    isValid(): boolean {

        let b: boolean = true;

        if (!this.formData.description) b = false;

        return b;
    }

    //BASE
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.entityClass = MainCatalogs_Classes.EvTaskDescriptGroup;

        this.dtg_Input_Description.setMaxLength(255);
        this.dtg_Input_Note.setMaxLength(2000);
        this.dtg_Input_Note.setValidationEnabled(false);
    }
    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

mdsLazyProto(EvTaskDescriptGroupEditor.prototype, {
  dtg_Input_Description: () => (new Edit()),
  dtg_Input_Note: () => (new Edit()),
  dtg_Input_Order: () => (new NumberInput()),
});
export default mdsWidget(EvTaskDescriptGroupEditor);